function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import memoizeOne from "memoize-one";
import { string, object, array } from "yup";
import { get as safeGet, last, concat } from "lodash";
import { context } from "../../components/wr-context";
import { uniqueArrayById } from "../../utils/array";
import safeJsonParse from "../../utils/safe-json-parse";
import { getLocalizedProperty } from "../../utils/i18n";
import { getProductRow, RowVariants } from "../../utils/product/get-product-row";
var parseFieldValue = function(v) {
    if (typeof v !== "string") {
        return v;
    }
    var value = v;
    if (value && value[0] === "{" && value[1] !== "{") {
        var parsedValue = JSON.parse(value);
        if (parsedValue.value && parsedValue.value !== "{}") {
            value = parsedValue.value;
        } else if (parsedValue.label) {
            value = parsedValue.label;
        }
    }
    return value;
};
export var checkIsInSkipRange = memoizeOne(function(ranges) {
    var _loop = function(i) {
        var n = rangesFlat[i][0];
        var precedingValues = rangesFlat.slice(0, i);
        var res = precedingValues.some(function(range) {
            return range && n > range[0] && n < (last(range[1]) || 0);
        });
        if (res) {
            if (context.constants.skipLogicMergePreviousRangeBeforeRemoval) {
                var prevIndex = rangesFlat.findIndex(function(range) {
                    return range[0] === precedingValues[0][0];
                });
                // if preceding intersecting range
                if (prevIndex > -1) {
                    rangesFlat[prevIndex][1] = concat(rangesFlat[i][1], rangesFlat[prevIndex][1].map(function(v) {
                        return v;
                    })).sort(function(numA, numB) {
                        return numA - numB;
                    });
                }
            }
            delete rangesFlat[i];
        }
    };
    var rangesFlat = Object.entries(ranges).map(function(param) {
        var _param = _slicedToArray(param, 2), start = _param[0], jumps = _param[1];
        return [
            Number(start),
            jumps
        ];
    }).sort(function(param, param1) {
        var _param = _slicedToArray(param, 1), startA = _param[0], _param1 = _slicedToArray(param1, 1), startB = _param1[0];
        return startA - startB;
    });
    // Calculate valid ranges to search in
    // Ranges intersecting with preceding ranges will be removed
    for(var i = 1; i < rangesFlat.length; i++)_loop(i);
    rangesFlat = rangesFlat.filter(Boolean);
    return function(n) {
        return rangesFlat.some(function(param) {
            var _param = _slicedToArray(param, 2), start = _param[0], jumps = _param[1];
            return n > start && n < (last(jumps) || 0) && !(jumps === null || jumps === void 0 ? void 0 : jumps.includes(n));
        });
    };
});
var hoursRe = /([+-]?([0-9]*[.])?[0-9]+)\s*hours?/i;
// Fields which can contain an hours value
var hoursFieldsWhitelist = new Set([
    "checkbox",
    "dropdown",
    "radio"
]);
export var mergeRowsValues = function(_formValues, product) {
    var additionalHours = 0;
    var values = _objectSpread({}, _formValues);
    var notes = [];
    var rows = product.rows;
    // Merge rows and values, parse values where necessary
    rows = product.rows.filter(function(row) {
        return values.hasOwnProperty(row.id);
    }).map(function(row) {
        var ref;
        var key = row.id;
        // Parse value
        var value = parseFieldValue(values[key]);
        var rawValue = values[key];
        // Get end date for datepicker ranges
        if (row.rowType === "datepicker" && ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isDateRange)) {
            var endValue = values[key + "_end"];
            row.dateEnd = endValue;
        }
        // Extract notes
        if (row.rowType === "radio" || row.rowType === "checkbox") {
            var ref1, ref2;
            var activeNotesItems = (ref1 = row.options) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.filter(function(v) {
                return Boolean(v.allowNotes) && (row.rowType === "radio" ? rawValue === v.value : value.includes(v.value));
            }).map(function(v) {
                var notesKey = "".concat(key, "_").concat(v.id, "_notes");
                var noteValue = null;
                if (values.hasOwnProperty(notesKey)) {
                    noteValue = values[notesKey];
                    delete values[notesKey];
                }
                return _objectSpreadProps(_objectSpread({}, v), {
                    noteValue: noteValue
                });
            }).filter(Boolean);
            notes = activeNotesItems || [];
        }
        delete values[key];
        return _objectSpreadProps(_objectSpread({}, row), {
            notes: notes,
            value: value,
            rawValue: rawValue
        });
    });
    // Remove rows hidden by skipRange
    if (values.skipRange && Object.keys(values.skipRange).length) {
        var isInSkipRange = checkIsInSkipRange(values.skipRange);
        rows = rows.filter(function(row) {
            return !isInSkipRange(row.order);
        });
    }
    // Calculate estimatedHours
    rows.filter(function(row) {
        return hoursFieldsWhitelist.has(row.rowType);
    }).forEach(function(v) {
        var values = Array.isArray(v.rawValue) ? v.rawValue : [
            v.rawValue
        ];
        values.forEach(function(rowValue) {
            var value = safeJsonParse(rowValue).value;
            var match = hoursRe.exec(value);
            if (match && match[1]) {
                var hours = parseFloat(match[1]);
                // Apply any multiplier fields to their respective options only
                var multiplier = 0;
                if (v.notes) {
                    v.notes.forEach(function(note) {
                        if (note.notesType === "multiplier" && note.noteValue && note.value === rowValue) {
                            multiplier += Number(note.noteValue);
                        }
                    });
                }
                additionalHours += hours * (multiplier || 1);
            }
        });
    });
    // Sum up all hours values from rows with one hidden, selected checkbox
    var fixedHours = rows.filter(function(v) {
        var ref, ref1, ref2, ref3, ref4;
        return v.rowType === "checkbox" && ((ref = v.options) === null || ref === void 0 ? void 0 : ref.access) === "hidden" && ((ref1 = v.options) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.length) === 1 && ((ref3 = v.options) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : ref4[0].isChecked);
    }).map(function(v) {
        var ref, ref1;
        var value = JSON.parse(((ref = v.options) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0].value) || "{}").value;
        var match = hoursRe.exec(value);
        if (match && match[1]) {
            return parseFloat(match[1]);
        } else {
            return 0;
        }
    }).reduce(function(acc, v) {
        return acc + v;
    }, 0) || null;
    return _objectSpreadProps(_objectSpread({}, product), {
        rows: rows,
        estimatedHours: (fixedHours || 0) + additionalHours
    });
};
export var createProductFilter = function() {
    var filterText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    filterText = filterText.trim();
    if (!filterText) return null;
    var parts = filterText.split(/\s+/).map(function(part) {
        return part.toLowerCase();
    });
    return {
        test: function(text) {
            text = text.toLowerCase();
            return parts.every(function(part) {
                return text.includes(part);
            });
        }
    };
};
export var filterProducts = function(catalogs, searchFilter, searchableKeys) {
    var productsToDisplay = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], priceFilter = arguments.length > 4 ? arguments[4] : void 0;
    var _state = context.state, categoryFilters = _state.categoryFilters, _activeFilters = _state.activeFilters, activeFilters = _activeFilters === void 0 ? [] : _activeFilters;
    var activeCategoryFilters = categoryFilters.length > 0;
    var categories = context.state.categories;
    var updatedProducts = [];
    var filterCreator = context.utils.createProductFilter || createProductFilter;
    var searchPattern = filterCreator === null || filterCreator === void 0 ? void 0 : filterCreator(searchFilter);
    catalogs.forEach(function(catalog) {
        var products = Array.isArray(catalog) ? catalog : catalog && catalog.contents ? catalog.contents.items : null;
        if (!products) return;
        activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.forEach(function(filt) {
            if (!products) return;
            products = products === null || products === void 0 ? void 0 : products.filter(function(prod) {
                var isInCategory = false;
                if (!prod.filters) return isInCategory;
                prod.filters.forEach(function(f) {
                    if (f.id === filt) {
                        isInCategory = true;
                    }
                });
                return isInCategory;
            });
        });
        if (productsToDisplay.length > 0) {
            products = products.filter(function(product) {
                return productsToDisplay.includes(product.id);
            });
        }
        if (searchFilter) {
            products = products.filter(function(v) {
                return searchPattern === null || searchPattern === void 0 ? void 0 : searchPattern.test(searchableKeys.map(function(k) {
                    return v[k];
                }).reduce(function(acc, s) {
                    return acc.concat(s);
                }, ""));
            });
        }
        if (priceFilter && context.state.priceFilter.maxValue) {
            products = products.filter(function(product) {
                var ref;
                var priceValue = parseInt(String(((ref = product.pricing) === null || ref === void 0 ? void 0 : ref.value) || 0));
                if (priceValue >= context.state.priceFilter.values[0] && priceValue <= context.state.priceFilter.values[1]) {
                    return product;
                }
            });
        }
        categories.forEach(function(category) {
            if (activeCategoryFilters && !categoryFilters.find(function(filter) {
                return filter === category.id;
            })) {
                return;
            }
            var productToAdd = (products || []).filter(function(product) {
                if (category.id === "category-undefined" && product.categories.length === 0) {
                    return product;
                } else {
                    return product.categories.find(function(cat) {
                        return category.id === cat.id;
                    });
                }
            });
            var categoryDefined = updatedProducts.find(function(cat) {
                return cat.hasOwnProperty([
                    category.id
                ]);
            });
            if (productToAdd.length) {
                if (categoryDefined) {
                    updatedProducts.forEach(function(cat) {
                        if (cat.hasOwnProperty([
                            category.id
                        ])) {
                            var _id;
                            var prod = Array.isArray(productToAdd) ? productToAdd : [
                                productToAdd
                            ];
                            (_id = cat[category.id]).push.apply(_id, _toConsumableArray(prod));
                        }
                    });
                } else {
                    updatedProducts.push(_defineProperty({}, category.id, productToAdd));
                }
            }
        });
        if (categories.length === 0) {
            updatedProducts.push({
                "category-undefined": products
            });
        }
    });
    return {
        products: updatedProducts,
        categories: categories
    };
};
export var sortProducts = function(products, sorting) {
    if (sorting) {
        switch(sorting.value){
            case "last_modified":
                products.sort(function(firstProduct, secondProduct) {
                    return new Date(secondProduct.updatedAt || secondProduct.createdAt).getTime() - new Date(firstProduct.updatedAt || firstProduct.createdAt).getTime();
                });
                break;
            case "default_order":
                products.sort(function(a, b) {
                    return (a.order || 0) - (b.order || 0);
                });
                break;
            case "a_z":
                products.sort(function(firstProduct, secondProduct) {
                    return firstProduct.name.localeCompare(secondProduct.name);
                });
                break;
            case "z_a":
                products.sort(function(firstProduct, secondProduct) {
                    return secondProduct.name.localeCompare(firstProduct.name);
                });
                break;
            default:
                if (sorting.func) {
                    products = sorting.func(products, {
                        sorting: sorting
                    });
                } else {
                    console.error("Unsupported sorting method");
                }
        }
    }
    return products;
};
var retrieveProducts = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var mappedProducts = [];
    products.map(function(productCategory) {
        return Object.keys(productCategory).map(function(key) {
            return productCategory[key].forEach(function(item) {
                return mappedProducts.push(item);
            });
        });
    });
    return uniqueArrayById(mappedProducts).sort(function(a, b) {
        return (a.order || 0) - (b.order || 0);
    });
};
var getPointPrice = function(product, credits) {
    var getPointPriceOverride = safeGet(context, "utils.product.getPointPrice");
    if (getPointPriceOverride) return getPointPriceOverride(product, credits);
    var price = 0;
    var pricingRow = getProductRow(product, RowVariants.RowType, "component:pricing");
    if (pricingRow && pricingRow.control) {
        var ref, ref1;
        price = ((ref = pricingRow.control) === null || ref === void 0 ? void 0 : (ref1 = ref.schedule) === null || ref1 === void 0 ? void 0 : ref1.serviceRateLabel) || 0;
    } else if (product.price || product.priceLabel) {
        price = product.price || product.priceLabel || 0;
    }
    if (credits) {
        price = String(product.price || product.priceLabel).replace(/\D+/g, "") || 0;
    }
    return Number(price);
};
export var getPrice = function(product, withoutDividing, credits) {
    var withDiscount = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var getPriceOverride = safeGet(context, "utils.product.getPrice");
    if (getPriceOverride) {
        return getPriceOverride(product, withoutDividing, credits, withDiscount);
    }
    var pointSystem = context.state.pointSystem;
    if (pointSystem) {
        return getPointPrice(product, credits);
    }
    var serviceRate = product.service_rate_cents, serviceRateL = product.service_rate_label, serviceRateCents = product.serviceRateCents, serviceRateLabel = product.serviceRateLabel, updatedPrice = product.price, priceLabel = product.priceLabel;
    var pricingRow = getProductRow(product, RowVariants.RowType, "component:pricing");
    var pricingBundle = product.groupType && product.groupType === "bundle" ? product.settings : null;
    var cents = serviceRate || serviceRateCents || updatedPrice;
    var label = serviceRateL || serviceRateLabel || priceLabel;
    var price = 0;
    if (pricingRow && pricingRow.control) {
        var control = typeof pricingRow.control === "string" ? JSON.parse(pricingRow.control) : pricingRow.control;
        price += control.schedule && control.schedule.cost ? control.schedule.cost / 100 || 0 : 0;
    }
    if (pricingBundle) {
        price += pricingBundle.cost ? pricingBundle.cost / 100 : 0;
        if (pricingBundle.serviceRateLabel) {
            var hasPrice = pricingBundle.serviceRateLabel.match(/[\d,]+/);
            if (hasPrice === null || hasPrice === void 0 ? void 0 : hasPrice.length) {
                var priceNumber = parseFloat(hasPrice[0].replace(",", ""));
                if (!isNaN(priceNumber)) {
                    if (pricingBundle.serviceRateLabel.toLowerCase().indexOf("day") !== -1) {} else if (pricingBundle.serviceRateLabel.toLowerCase().indexOf("week") !== -1) {
                        price += priceNumber * 52;
                    } else if (pricingBundle.serviceRateLabel.toLowerCase().indexOf("month") !== -1) {
                        price += priceNumber * 12;
                    } else {
                        price += priceNumber;
                    }
                }
            }
        }
    }
    if (cents && !pricingRow) {
        price += withoutDividing ? cents : cents / 100;
    } else if (label && !pricingRow) {
        var hasPrice1 = String(label).match(/[\d,]+/);
        if (hasPrice1 === null || hasPrice1 === void 0 ? void 0 : hasPrice1.length) {
            var priceNumber1 = parseFloat(hasPrice1[0].replace(",", ""));
            if (!isNaN(priceNumber1)) {
                if (String(label).toLowerCase().indexOf("day") !== -1) {} else if (String(label).toLowerCase().indexOf("week") !== -1) {
                    price += priceNumber1 * 52;
                } else if (String(label).toLowerCase().indexOf("month") !== -1) {
                    price += priceNumber1 * 12;
                } else {
                    price += priceNumber1;
                }
            }
        }
    }
    if (product.options && product.options.length) {
        product.options.forEach(function(opt) {
            var value = opt.value || 0;
            var multiplier = !isNaN(opt.multiplier || 1) ? opt.multiplier || 1 : 1;
            price += value * multiplier;
        });
    }
    return price;
};
var getListPrice = function(product) {
    var getListPriceOverride = safeGet(context, "utils.product.getListPrice");
    if (getListPriceOverride) {
        return getListPriceOverride(product);
    }
    var pointSystem = context.state.pointSystem;
    if (pointSystem) {
        return getPointPrice(product);
    }
    var serviceRateLabel = product.service_rate_label || product.serviceRateLabel || "";
    var serviceRatePrice = product.service_rate_cents || product.serviceRateCents || 0;
    var servicePrice = serviceRatePrice ? "$".concat((serviceRatePrice / 100).toLocaleString()) : null;
    var pricingRow = getProductRow(product, RowVariants.RowType, "component:pricing");
    var pricingControl = pricingRow && pricingRow.control ? typeof pricingRow.control === "string" ? JSON.parse(pricingRow.control) : pricingRow.control : null;
    var pricingControlValue = pricingControl && pricingControl.schedule ? "$".concat((pricingControl.schedule.cost / 100).toLocaleString()) : "$".concat(0..toLocaleString());
    return serviceRateLabel || servicePrice || pricingControlValue;
};
var getListDuration = function(product) {
    var duration = product.duration || 0;
    if (product.rows) {
        var durationValue = product.rows.find(function(row) {
            return row.label.replace("[CUSTOMER FACING]", "").trim() === "Duration";
        });
        if (durationValue && !isNaN(Number(durationValue.control))) {
            duration = product.duration = Number(durationValue.control);
        }
    }
    if (product.serviceRateLabel && product.serviceRateLabel !== "") {
        var m = product.serviceRateLabel.match(/[\d,]+/);
        if (m === null || m === void 0 ? void 0 : m.length) {
            var n = parseInt(((m === null || m === void 0 ? void 0 : m[0]) || "").replace(",", ""), 10);
            if (!isNaN(n)) {
                if (product.serviceRateLabel.toLowerCase().indexOf("day") !== -1) {
                    duration = n * 8;
                } else if (product.serviceRateLabel.toLowerCase().indexOf("week") !== -1) {
                    duration = n * 40;
                }
            }
        }
    }
    return duration;
};
/**
 * Works both for regular price (currency) and point price
 */ export var getDiscountedAddOnPrice = function(price, addOnConfig) {
    var discountType = addOnConfig.discountType, discountValue = addOnConfig.discountValue;
    var finalValue = discountValue;
    if (!finalValue && finalValue !== 0) return price;
    finalValue = Number(finalValue);
    if (isNaN(finalValue)) return price;
    switch(discountType){
        case "percent":
            return price * (100 - finalValue) / 100;
        case "dollar":
            return price - finalValue;
        case "flat-rate":
            return finalValue;
    }
};
export var getRowsSummary = function(rows) {
    return rows.filter(function(v) {
        return Boolean(v.value) && safeGet(v, "options.access") !== "hidden";
    }).map(function(row) {
        var ref;
        if (row.rowType === "radio" || row.rowType === "dropdown") {
            var ref1;
            var item = (((ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.items) || []).find(function(v) {
                return v.value === row.rawValue;
            });
            return {
                label: getLocalizedProperty(row, "label"),
                value: item ? getLocalizedProperty(item, "label") || getLocalizedProperty(row, "value") : getLocalizedProperty(row, "value"),
                notes: row.notes
            };
        } else if (row.rowType === "checkbox") {
            var values = row.value.map(function(v) {
                var ref, ref1;
                return (ref = row.options) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                    return item.value === v;
                });
            }).filter(Boolean);
            return {
                label: getLocalizedProperty(row, "label"),
                value: values.map(function(v) {
                    return {
                        label: getLocalizedProperty(v, "label"),
                        value: getLocalizedProperty(v, "value")
                    };
                }),
                notes: row.notes
            };
        } else if (row.rowType === "datepicker" && ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isDateRange)) {
            return {
                label: getLocalizedProperty(row, "label"),
                value: "".concat(row.value, " - ").concat(row.dateEnd),
                notes: row.notes
            };
        } else {
            return {
                label: getLocalizedProperty(row, "label"),
                value: row.value,
                notes: row.notes
            };
        }
    });
};
export var getProductValidationSchema = memoizeOne(function(rows) {
    var skipRange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var validations = {};
    var isInSkipRange = checkIsInSkipRange(skipRange);
    var validatableRows = rows.filter(function(row) {
        return !isInSkipRange(row.order);
    });
    validatableRows.forEach(function(row) {
        var ref;
        if ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isRequired) {
            var ref1;
            if (row.rowType === "checkbox") {
                validations[row.id] = array().required("* required");
            } else if (row.rowType === "datepicker" && ((ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.isDateRange)) {
                validations[row.id] = string().required("* required");
                validations[row.id + "_end"] = string().required("* required");
            } else {
                var ref2, ref3, ref4;
                if (((ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.inputType) && ((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.inputType) === "numeric") {
                    validations[row.id] = string().matches(/^\d+$/, "* Must be a valid number").required("* required");
                } else if (row.rowType === "free-text" && ((ref4 = row.options) === null || ref4 === void 0 ? void 0 : ref4.isEditor)) {
                    validations[row.id] = object().shape({
                        value: string().required("* required")
                    });
                } else {
                    validations[row.id] = string().required("* required");
                }
            }
        } else {
            var ref5;
            if (row.rowType === "checkbox") {
                validations[row.id] = array().nullable();
            } else if (row.rowType === "datepicker" && ((ref5 = row.options) === null || ref5 === void 0 ? void 0 : ref5.isDateRange)) {
                validations[row.id] = string();
                validations[row.id + "_end"] = string();
            } else {
                var ref6, ref7, ref8;
                if (((ref6 = row.options) === null || ref6 === void 0 ? void 0 : ref6.inputType) && ((ref7 = row.options) === null || ref7 === void 0 ? void 0 : ref7.inputType) === "numeric") {
                    validations[row.id] = string().matches(/^\d+$/, {
                        message: "* Must be a valid number",
                        excludeEmptyString: true
                    });
                } else if (row.rowType === "free-text" && ((ref8 = row.options) === null || ref8 === void 0 ? void 0 : ref8.isEditor)) {
                    validations[row.id] = object().shape({
                        value: string()
                    });
                } else {
                    validations[row.id] = string();
                }
            }
        }
    });
    if (context.constants.overrideProductValidationSchema) {
        context.constants.overrideProductValidationSchema(validations, validatableRows, skipRange);
    }
    return object(validations);
});
var getDropdownInitialValue = function(row) {
    var ref, ref1;
    return (((ref = row.options) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
        return v.isChecked;
    })) || {}).value || "";
};
var getDefaultRowValue = function(row) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    return row.control || ((ref = row.options) === null || ref === void 0 ? void 0 : ref.defaultValue) || defaultValue;
};
function reduceObj(acc, v) {
    return _objectSpread({}, acc, v);
}
var getProductFormikInitialValues = memoizeOne(function(rows) {
    var skipRange = {};
    var defaultValues = rows.map(function(row) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var noteFields = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.items) ? (ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.items.filter(function(v) {
            return v.allowNotes;
        }) : [];
        var defaultValue = _objectSpread(_defineProperty({}, "".concat(row.id), ""), row.rowType === "datepicker" && ((ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.isDateRange) ? _defineProperty({}, "".concat(row.id, "_end"), "") : {}, noteFields.map(function(note) {
            return _defineProperty({}, "".concat(row.id, "_").concat(note.id, "_notes"), note.notesType === "multiplier" ? "1" : "");
        }).reduce(reduceObj, {}), row.rowType === "text" && row.control ? _defineProperty({}, "".concat(row.id), row.control) : {}, row.rowType === "dropdown" && row.control ? _defineProperty({}, "".concat(row.id), getDropdownInitialValue(row)) : {}, row.rowType === "free-text" && ((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.isEditor) && getDefaultRowValue(row) ? _defineProperty({}, "".concat(row.id), {
            value: getDefaultRowValue(row),
            tag: (ref4 = row.options) === null || ref4 === void 0 ? void 0 : ref4.tag
        }) : {});
        // set defaults for some fields
        if (row.options && ((ref5 = row.options) === null || ref5 === void 0 ? void 0 : ref5.hasQuestionnaire)) {
            if ([
                "checkbox",
                "radio",
                "dropdown"
            ].includes(row.rowType)) {
                var ref6;
                if ((ref6 = row.options) === null || ref6 === void 0 ? void 0 : ref6.items) {
                    var ref7;
                    (ref7 = row.options) === null || ref7 === void 0 ? void 0 : ref7.items.forEach(function(option) {
                        if (option && option.isChecked) {
                            if (option.skipTo) {
                                skipRange[row.order] = parseSkipTo(option.skipTo);
                            }
                            if (row.rowType === "checkbox") {
                                defaultValue[row.id] = (defaultValue[row.id] || []).concat([
                                    option.value
                                ]);
                            } else {
                                defaultValue[row.id] = option.value;
                            }
                        }
                    });
                }
            }
        }
        return defaultValue;
    }).reduce(reduceObj, {});
    defaultValues.skipRange = skipRange;
    return defaultValues;
});
export var parseSkipTo = function(skipTo) {
    return skipTo.trim().split(/\s*,\s*/).map(function(jump) {
        return jump.toLowerCase() === "end" ? Number.POSITIVE_INFINITY : Number(jump);
    }).sort(function(a, b) {
        return a - b;
    });
};
export default {
    mergeRowsValues: mergeRowsValues,
    createProductFilter: createProductFilter,
    filterProducts: filterProducts,
    sortProducts: sortProducts,
    getPrice: getPrice,
    retrieveProducts: retrieveProducts,
    getProductValidationSchema: getProductValidationSchema,
    getListPrice: getListPrice,
    getListDuration: getListDuration,
    getProductFormikInitialValues: getProductFormikInitialValues,
    checkIsInSkipRange: checkIsInSkipRange,
    getRowsSummary: getRowsSummary
};
